import YFormIcibVerifyOrganization from './IcibVerifyOrganization';

export { YFormIcibVerifyOrganization };
export default YFormIcibVerifyOrganization;
